<template>
  <div>
    <h3 class="title dw_green--text font-weight-light">
      <v-icon color="dw_green" class="mr-2 mb-1" v-text="mdiSwordCross" />
      NIST SP 800-53 Controls
    </h3>
    <v-row no-gutters>
      <v-col cols="11">
        <v-text-field
          v-model="search"
          @change="searchExisting"
          @click:clear="search = ''; searchExisting()"
          label="Search Controls"
          :append-icon="mdiMagnify"
          color="dw_green"
          hide-details
          clearable
        ></v-text-field>
      </v-col>
    </v-row>
    <v-card width="33vw" max-height="50vh" class="pa-2 my-2 existing-list">
      <p v-for="ctrl of controls" :key="ctrl" class="grey--text caption mb-1">{{ ctrl }}</p>
    </v-card>
  </div>
</template>

<script>
import { mdiSwordCross, mdiMagnify } from '@mdi/js';
import { mapGetters } from 'vuex';

export default {
  name: 'controlList',
  data() {
    return {
      mdiSwordCross,
      mdiMagnify,
      search: '',
      controls: []
    }
  },
  computed: {
    ...mapGetters([
      'controlOptions'
    ])
  },
  mounted() {
    this.controls = this.controlOptions.map((control) => control.label);
  },
  methods: {
    searchExisting() {
      this.controls = this.controlOptions.map((control) => control.label);
      if (this.search !== '') {
        this.controls = this.controls.filter((control) => {
          const s = this.search.toLowerCase();
          return control.toLowerCase().includes(s);
        });
      }
    }
  }
};
</script>

<style scoped>
.existing-list {
  height: inherit;
  overflow-y: scroll;
}
</style>
